module.exports = __webpack_public_path__ + "static/deva-34a19864854e4f53ce72d8c0ec056cd2.jpg";